import { Calculator } from '../../../utils/calculator';

const calculator = new Calculator();

/**
 * mapping of air control types to corresponding icons
 */
const airControlImageTypes = {
  'ac off': 'assets/images/icon-fan-gray.svg',
  'ac on': 'assets/images/icon-fan-white.svg',
  'heat off': 'assets/images/icon-wave-gray.svg',
  'heat on': 'assets/images/icon-wave-white.svg',
};

/**
 * Performs syncronization between the calculator and the UI.
 */
const syncFromCalc = () => {
  const airControlBtn = document.getElementById('air-control');
  const airDescription = document.getElementById('air-description');
  const speed = document.getElementById('speed');
  const speedUp = document.getElementById('speed-up');
  const speedDown = document.getElementById('speed-down');
  const temperature = document.getElementById('temperature');
  const temperatureUp = document.getElementById('temperature-up');
  const temperatureDown = document.getElementById('temperature-down');
  const metric1 = document.getElementById('metric-1');
  const metric2 = document.getElementById('metric-2');

  speed.value = calculator.speed;
  temperature.value = calculator.temperature;
  airDescription.innerText = calculator.airControl;
  metric1.innerText = calculator.metric100d.kilometers;
  metric2.innerText = calculator.metricp100d.kilometers;

  airControlBtn.classList.remove('ac-on', 'ac-off', 'heat-on', 'heat-off');
  airControlBtn.classList.add(calculator.airControl.replace(' ', '-'));
  airControlBtn.children[1].src = airControlImageTypes[calculator.airControl];

  temperatureUp.classList.remove('limit');
  temperatureDown.classList.remove('limit');
  speedUp.classList.remove('limit');
  speedDown.classList.remove('limit');

  if (calculator.temperature >= 40) {
    temperatureUp.classList.add('limit');
  }

  if (calculator.temperature <= -10) {
    temperatureDown.classList.add('limit');
  }

  if (calculator.speed >= 140) {
    speedUp.classList.add('limit');
  }

  if (calculator.speed <= 70) {
    speedDown.classList.add('limit');
  }
};

/**
 * Main listeners for the UI interaction.
 */
const listeners = () => {
  const airControlBtn = document.getElementById('air-control');
  const speed = document.getElementById('speed');
  const speedUp = document.getElementById('speed-up');
  const speedDown = document.getElementById('speed-down');
  const temperature = document.getElementById('temperature');
  const temperatureUp = document.getElementById('temperature-up');
  const temperatureDown = document.getElementById('temperature-down');
  const wheel19 = document.getElementById('wheel-19');
  const wheel21 = document.getElementById('wheel-21');

  airControlBtn.addEventListener('click', (event) => {
    event.preventDefault();
    calculator.toggleAirControl();
    syncFromCalc();
  });

  wheel19.addEventListener('click', (event) => {
    event.preventDefault();
    wheel21.classList.remove('selected');
    wheel19.classList.add('selected');
    calculator.changeWheelSize(19);
    syncFromCalc();
  });

  wheel21.addEventListener('click', (event) => {
    event.preventDefault();
    wheel19.classList.remove('selected');
    wheel21.classList.add('selected');
    calculator.changeWheelSize(21);
    syncFromCalc();
  });

  speedUp.addEventListener(
    'click',
    (event) => {
      event.preventDefault();
      if (speed.value >= 140) return;
      calculator.increaseSpeed();
      syncFromCalc();
    },
    false
  );

  speedDown.addEventListener(
    'click',
    (event) => {
      event.preventDefault();
      if (speed.value <= 70) return;
      calculator.decreaseSpeed();
      syncFromCalc();
    },
    false
  );

  temperatureUp.addEventListener(
    'click',
    (event) => {
      event.preventDefault();
      if (temperature.value >= 40) return;
      calculator.increaseTemperature();
      syncFromCalc();
    },
    false
  );

  temperatureDown.addEventListener(
    'click',
    (event) => {
      event.preventDefault();
      if (temperature.value <= -10) return;
      calculator.decreaseTemperature();
      syncFromCalc();
    },
    false
  );
};

/**
 * Initializes the calculator controller and listener events.
 */
const init = () => {
  syncFromCalc();
  listeners();
};

export default init;
